module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "12e0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".footerSource a{color:#3273dc!important}", ""]);

// exports


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "2350":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "26a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FAQ_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("99fc");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FAQ_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FAQ_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FAQ_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "3748":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
var URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
var isValidURL = function (str) { return URL_LONG.test(str) || URL_SHORT.test(str); };
function createStyle(doc, cssText) {
    var style = doc.createElement("style");
    style.type = "text/css";
    style.appendChild(window.document.createTextNode(cssText));
    return style;
}
exports.createStyle = createStyle;
function createLinkStyle(doc, url) {
    var style = doc.createElement("link");
    style.type = "text/css";
    style.rel = "stylesheet";
    style.href = url;
    return style;
}
exports.createLinkStyle = createLinkStyle;
function createIFrame(parent) {
    var el = window.document.createElement("iframe");
    el.setAttribute("src", "about:blank");
    el.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;");
    el.setAttribute("width", "0");
    el.setAttribute("height", "0");
    el.setAttribute("wmode", "opaque");
    parent.appendChild(el);
    return el;
}
exports.createIFrame = createIFrame;
var DEFAULT_OPTIONS = {
    parent: window.document.body,
    headElements: [],
    bodyElements: []
};
/** Printd class that prints HTML elements in a blank document */
var Printd = /** @class */ (function () {
    function Printd(options) {
        this.isLoading = false;
        this.hasEvents = false;
        // IE 11+ "Object.assign" polyfill
        this.opts = [DEFAULT_OPTIONS, options || {}].reduce(function (a, b) {
            Object.keys(b).forEach(function (k) { return (a[k] = b[k]); });
            return a;
        }, {});
        this.iframe = createIFrame(this.opts.parent);
    }
    /** Gets current Iframe reference */
    Printd.prototype.getIFrame = function () {
        return this.iframe;
    };
    /**
     * Print an HTMLElement
     *
     * @param el HTMLElement
     * @param styles Optional styles (css texts or urls) that will add to iframe document.head
     * @param scripts Optional scripts (script texts or urls) that will add to iframe document.body
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.print = function (el, styles, scripts, callback) {
        if (this.isLoading)
            return;
        var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow = _a.contentWindow;
        if (!contentDocument || !contentWindow)
            return;
        this.iframe.src = "about:blank";
        this.elCopy = el.cloneNode(true);
        if (!this.elCopy)
            return;
        this.isLoading = true;
        this.callback = callback;
        var doc = contentWindow.document;
        doc.open();
        doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
        this.addEvents();
        // 1. append custom elements
        var _b = this.opts, headElements = _b.headElements, bodyElements = _b.bodyElements;
        // 1.1 append custom head elements
        if (Array.isArray(headElements)) {
            headElements.forEach(function (el) { return doc.head.appendChild(el); });
        }
        // 1.1 append custom body elements
        if (Array.isArray(bodyElements)) {
            bodyElements.forEach(function (el) { return doc.body.appendChild(el); });
        }
        // 2. append custom styles
        if (Array.isArray(styles)) {
            styles.forEach(function (value) {
                if (value) {
                    doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
                }
            });
        }
        // 3. append element copy
        doc.body.appendChild(this.elCopy);
        // 4. append custom scripts
        if (Array.isArray(scripts)) {
            scripts.forEach(function (value) {
                if (value) {
                    var script = doc.createElement("script");
                    if (isValidURL(value)) {
                        script.src = value;
                    }
                    else {
                        script.innerText = value;
                    }
                    doc.body.appendChild(script);
                }
            });
        }
        doc.close();
    };
    /**
     * Print an URL
     *
     * @param url URL to print
     * @param callback Optional callback that will be triggered when content is ready to print
     */
    Printd.prototype.printURL = function (url, callback) {
        if (this.isLoading)
            return;
        this.addEvents();
        this.isLoading = true;
        this.callback = callback;
        this.iframe.src = url;
    };
    Printd.prototype.launchPrint = function (contentWindow) {
        var result = contentWindow.document.execCommand("print", false, undefined);
        if (!result) {
            contentWindow.print();
        }
    };
    Printd.prototype.addEvents = function () {
        var _this = this;
        if (!this.hasEvents) {
            this.hasEvents = true;
            this.iframe.addEventListener("load", function () { return _this.onLoad(); }, false);
        }
    };
    Printd.prototype.onLoad = function () {
        var _this = this;
        if (this.iframe) {
            this.isLoading = false;
            var _a = this.iframe, contentDocument = _a.contentDocument, contentWindow_1 = _a.contentWindow;
            if (!contentDocument || !contentWindow_1)
                return;
            if (this.callback) {
                this.callback({
                    iframe: this.iframe,
                    element: this.elCopy,
                    launchPrint: function () { return _this.launchPrint(contentWindow_1); }
                });
            }
            else {
                this.launchPrint(contentWindow_1);
            }
        }
    };
    return Printd;
}());
exports.Printd = Printd;
exports.default = Printd;


/***/ }),

/***/ "3798":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("12e0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("13db09fe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3821":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("be7f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6b42ae7e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "3de3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SourceFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3798");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SourceFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SourceFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SourceFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return addStylesClient; });
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5446":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3821");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BaseFooter_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "9660":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".footerSourceModal h3{margin:1em 0!important}.footerSourceModal p{margin-bottom:1em!important}.footerSourceModal ul{list-style:inside!important;list-style-type:disc!important;padding-bottom:10px!important}.footerSourceModal a{color:#3273dc!important}.footerSourceModal-head{padding-top:5px!important;padding-bottom:5px!important}.footerSourceModal-title{padding-bottom:0!important;margin-bottom:0!important}.footerSourceModal-foot{padding-top:5px!important;padding-bottom:5px!important}", ""]);

// exports


/***/ }),

/***/ "99fc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9660");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("253d8e15", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "be7f":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("2350")(false);
// imports


// module
exports.push([module.i, ".basefooter .card-footer-header{background:#fafafa}.basefooter .card-footer-header .columns{margin:0}.basefooter .card-footer-header .column{border:none!important}.basefooter .card-footer-item{background:#f8f8f8;-webkit-box-pack:left!important;-ms-flex-pack:left!important;justify-content:left!important;padding-left:1.5em;padding-right:.75em;border:none!important;opacity:.8}.basefooter .card-footer-item span.flink{display:inline-block;margin-right:1.6em}.basefooter .card-footer-item a{text-decoration:underline}.basefooter .card-footer-content{background:#fafafa!important;padding-left:1.5em!important;padding-right:1.5em!important;padding-top:0!important;padding-bottom:1.5em!important}.basefooter .collapse,.basefooter .footer{display:block!important}", ""]);

// exports


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseFooter.vue?vue&type=template&id=1a3bbd71&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"basefooter"},[_c('source-footer',{attrs:{"lang":_vm.toggleLang,"source":_vm.source,"summary":_vm.summary,"summaryContent":_vm.summaryContent,"faq":_vm.faq}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseFooter.vue?vue&type=template&id=1a3bbd71&

// CONCATENATED MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
/*!
 * vue-i18n v8.14.1 
 * (c) 2019 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'style',
  'currency',
  'currencyDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'localeMatcher',
  'formatMatcher'
];

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

function vue_i18n_esm_isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var vue_i18n_esm_toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return vue_i18n_esm_toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (vue_i18n_esm_isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (vue_i18n_esm_isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

var vue_i18n_esm_hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return vue_i18n_esm_hasOwnProperty.call(obj, key)
}

function merge (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (vue_i18n_esm_isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = vue_i18n_esm_isObject(a);
  var isObjectB = vue_i18n_esm_isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
            if (false) {}
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root;
          options.i18n.formatter = this.$root.$i18n.formatter;
          options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
          options.i18n.formatFallbackMessages = this.$root.$i18n.formatFallbackMessages;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
          options.i18n.silentFallbackWarn = this.$root.$i18n.silentFallbackWarn;
          options.i18n.pluralizationRules = this.$root.$i18n.pluralizationRules;
          options.i18n.preserveDirectiveContent = this.$root.$i18n.preserveDirectiveContent;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
            if (false) {}
          }
        }

        var ref = options.i18n;
        var sharedMessages = ref.sharedMessages;
        if (sharedMessages && isPlainObject(sharedMessages)) {
          options.i18n.messages = merge(options.i18n.messages, sharedMessages);
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }
      } else {
        if (false) {}
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
    }
  },

  beforeMount: function beforeMount () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else {
        if (false) {}
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    var self = this;
    this.$nextTick(function () {
      if (self._subscribing) {
        self._i18n.unsubscribeDataChanging(self);
        delete self._subscribing;
      }

      if (self._i18nWatcher) {
        self._i18nWatcher();
        self._i18n.destroyVM();
        delete self._i18nWatcher;
      }

      if (self._localeWatcher) {
        self._localeWatcher();
        delete self._localeWatcher;
      }

      self._i18n = null;
    });
  }
};

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: String
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      if (false) {}
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = props.tag || 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};
  
  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);
  if (false) {}

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {
  if (false) {}

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      if (false) {}
      return null
    }

    var key = null;
    var options = null;

    if (typeof props.format === 'string') {
      key = props.format;
    } else if (vue_i18n_esm_isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (numberFormatKeys.includes(prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    return h(props.tag, {
      attrs: data.attrs,
      'class': data['class'],
      staticClass: data.staticClass
    }, values)
  }
};

/*  */

function bind (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (typeof value === 'string') {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var vue_i18n_esm_Vue;

function vue_i18n_esm_install (_Vue) {
  /* istanbul ignore if */
  if (false) {}
  vue_i18n_esm_install.installed = true;

  vue_i18n_esm_Vue = _Vue;

  var version = (vue_i18n_esm_Vue.version && Number(vue_i18n_esm_Vue.version.split('.')[0])) || -1;
  /* istanbul ignore if */
  if (false) {}

  extend(vue_i18n_esm_Vue);
  vue_i18n_esm_Vue.mixin(mixin);
  vue_i18n_esm_Vue.directive('t', { bind: bind, update: update, unbind: unbind });
  vue_i18n_esm_Vue.component(interpolationComponent.name, interpolationComponent);
  vue_i18n_esm_Vue.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = vue_i18n_esm_Vue.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : vue_i18n_esm_isObject(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        } else {
          if (false) {}
        }
        break
      case 'unknown':
        if (false) {}
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!vue_i18n_esm_isObject(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var formatters = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!vue_i18n_esm_Vue && typeof window !== 'undefined' && window.Vue) {
    vue_i18n_esm_install(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (Array.isArray(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (typeof message === 'string') {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = vue_i18n_esm_Vue.config.silent;
  vue_i18n_esm_Vue.config.silent = true;
  this._vm = new vue_i18n_esm_Vue({ data: data });
  vue_i18n_esm_Vue.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      vue_i18n_esm_Vue.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.$i18n.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (typeof missingRet === 'string') {
      return missingRet
    }
  } else {
    if (false) {}
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, 'string', parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {}
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {}
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (visitedLinkStack.includes(linkPlaceholder)) {
      if (false) {}
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      if (false) {}
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      Array.isArray(values) ? values : [values]
    );
    if (formatters.hasOwnProperty(formatterName)) {
      translated = formatters[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' ? ret.join('') : ret
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var res =
    this._interpolate(locale, messages[locale], key, host, interpolateMode, args, [key]);
  if (!isNull(res)) { return res }

  res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args, [key]);
  if (!isNull(res)) {
    if (false) {}
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host, values)
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values])
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (typeof locale !== 'string') {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

/**
 * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
 * @param choicesLength {number} an overall amount of available choices
 * @returns a final choice index
*/
VueI18n.prototype.getChoiceIndex = function getChoiceIndex (choice, choicesLength) {
  // Default (old) getChoiceIndex implementation - english-compatible
  var defaultImpl = function (_choice, _choicesLength) {
    _choice = Math.abs(_choice);

    if (_choicesLength === 2) {
      return _choice
        ? _choice > 1
          ? 1
          : 0
        : 1
    }

    return _choice ? Math.min(_choice, 2) : 0
  };

  if (this.locale in this.pluralizationRules) {
    return this.pluralizationRules[this.locale].apply(this, [choice, choicesLength])
  } else {
    return defaultImpl(choice, choicesLength)
  }
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
    if (this._warnHtmlInMessage === 'error') { return }
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
    if (this._warnHtmlInMessage === 'error') { return }
  }
  this._vm.$set(this._vm.messages, locale, merge(this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {}
    _locale = fallback;
    formats = dateTimeFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {
  /* istanbul ignore if */
  if (false) {}

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (vue_i18n_esm_isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  // fallback locale
  if (isNull(formats) || isNull(formats[key])) {
    if (false) {}
    _locale = fallback;
    formats = numberFormats[_locale];
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) {}
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (typeof args[0] === 'string') {
      key = args[0];
    } else if (vue_i18n_esm_isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (numberFormatKeys.includes(key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      key = args[0];
    }
    if (typeof args[1] === 'string') {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    if (false) {}
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (false) {}
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = vue_i18n_esm_install;
VueI18n.version = '8.14.1';

/* harmony default export */ var vue_i18n_esm = (VueI18n);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SourceFooter.vue?vue&type=template&id=782032f0&
var SourceFootervue_type_template_id_782032f0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{attrs:{"open":_vm.FooterisOpen},on:{"update:open":function($event){_vm.FooterisOpen=$event}}},[_c('div',{staticClass:"card-footer-header",attrs:{"slot":"trigger"},slot:"trigger"},[_c('div',{staticClass:"card-footer-item footerSource"},[_c('span',{staticClass:"flink",domProps:{"innerHTML":_vm._s(_vm.source)}}),(_vm.summary)?_c('span',{staticClass:"flink"},[_c('a',{attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.simulateClick()}}},[_c('b-icon',{attrs:{"icon":_vm.FooterisOpen ? 'minus-square' : 'plus-square',"pack":"fa","type":"is-info","size":"is-small"}}),_vm._v("Note")],1)]):_vm._e(),(_vm.faq != null)?_c('span',{staticClass:"flink"},[_c('faq-link',{attrs:{"lang":_vm.toggleLang,"faq":_vm.faq}})],1):_vm._e()])]),(_vm.summary)?_c('div',{staticClass:"card-footer-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.summaryContent)}})]):_vm._e()])}
var SourceFootervue_type_template_id_782032f0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/SourceFooter.vue?vue&type=template&id=782032f0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FAQ.vue?vue&type=template&id=5fcb1ad6&
var FAQvue_type_template_id_5fcb1ad6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.openModal()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openModal()}}},[_vm._v("FAQ")])])}
var FAQvue_type_template_id_5fcb1ad6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/FAQ.vue?vue&type=template&id=5fcb1ad6&

// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-cca88db8.js
function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var use = function use(plugin) {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
  }
};
var registerComponent = function registerComponent(Vue, component) {
  Vue.component(component.name, component);
};
var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
  if (!Vue.prototype.$buefy) Vue.prototype.$buefy = {};
  Vue.prototype.$buefy[property] = component;
};



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-17755bd7.js
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-8716473c.js


/**
 * Get value of an object property/path even if it's nested
 */
function getValueByPath(obj, path) {
  var value = path.split('.').reduce(function (o, i) {
    return o[i];
  }, obj);
  return value;
}
/**
 * Extension of indexOf method by equality function if specified
 */

function indexOf(array, obj, fn) {
  if (!array) return -1;
  if (!fn || typeof fn !== 'function') return array.indexOf(obj);

  for (var i = 0; i < array.length; i++) {
    if (fn(array[i], obj)) {
      return i;
    }
  }

  return -1;
}
/**
* Merge function to replace Object.assign with deep merging possibility
*/

var chunk_8716473c_isObject = function isObject(item) {
  return _typeof(item) === 'object' && !Array.isArray(item);
};

var chunk_8716473c_mergeFn = function mergeFn(target, source) {
  var isDeep = function isDeep(prop) {
    return chunk_8716473c_isObject(source[prop]) && target.hasOwnProperty(prop) && chunk_8716473c_isObject(target[prop]);
  };

  var replaced = Object.getOwnPropertyNames(source).map(function (prop) {
    return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop]) : source[prop]);
  }).reduce(function (a, b) {
    return _objectSpread2({}, a, {}, b);
  }, {});
  return _objectSpread2({}, target, {}, replaced);
};

var chunk_8716473c_merge = chunk_8716473c_mergeFn;
/**
 * Mobile detection
 * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */

var isMobile = {
  Android: function Android() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return typeof window !== 'undefined' && window.navigator.userAgent.match(/IEMobile/i);
  },
  any: function any() {
    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
  }
};
function removeElement(el) {
  if (typeof el.remove !== 'undefined') {
    el.remove();
  } else if (typeof el.parentNode !== 'undefined') {
    el.parentNode.removeChild(el);
  }
}



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-5160dcda.js
var config = {
  defaultContainerElement: null,
  defaultIconPack: 'mdi',
  defaultIconComponent: null,
  defaultIconPrev: 'chevron-left',
  defaultIconNext: 'chevron-right',
  defaultDialogConfirmText: null,
  defaultDialogCancelText: null,
  defaultSnackbarDuration: 3500,
  defaultSnackbarPosition: null,
  defaultToastDuration: 2000,
  defaultToastPosition: null,
  defaultNotificationDuration: 2000,
  defaultNotificationPosition: null,
  defaultTooltipType: 'is-primary',
  defaultTooltipAnimated: false,
  defaultTooltipDelay: 0,
  defaultInputAutocomplete: 'on',
  defaultDateFormatter: null,
  defaultDateParser: null,
  defaultDateCreator: null,
  defaultDayNames: null,
  defaultMonthNames: null,
  defaultFirstDayOfWeek: null,
  defaultUnselectableDaysOfWeek: null,
  defaultTimeFormatter: null,
  defaultTimeParser: null,
  defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
  defaultModalScroll: null,
  defaultDatepickerMobileNative: true,
  defaultTimepickerMobileNative: true,
  defaultNoticeQueue: true,
  defaultInputHasCounter: true,
  defaultTaginputHasCounter: true,
  defaultUseHtml5Validation: true,
  defaultDropdownMobileModal: true,
  defaultFieldLabelPosition: null,
  defaultDatepickerYearsRange: [-100, 3],
  defaultDatepickerNearbyMonthDays: true,
  defaultDatepickerNearbySelectableMonthDays: false,
  defaultDatepickerShowWeekNumber: false,
  customIconPacks: null
};
var config$1 = config;
var setOptions = function setOptions(options) {
  config = options;
};



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-aea983ae.js




//
var script = {
  name: 'BModal',
  props: {
    active: Boolean,
    component: [Object, Function],
    content: String,
    programmatic: Boolean,
    props: Object,
    events: Object,
    width: {
      type: [String, Number],
      default: 960
    },
    hasModalCard: Boolean,
    animation: {
      type: String,
      default: 'zoom-out'
    },
    canCancel: {
      type: [Array, Boolean],
      default: function _default() {
        return config$1.defaultModalCanCancel;
      }
    },
    onCancel: {
      type: Function,
      default: function _default() {}
    },
    scroll: {
      type: String,
      default: function _default() {
        return config$1.defaultModalScroll ? config$1.defaultModalScroll : 'clip';
      },
      validator: function validator(value) {
        return ['clip', 'keep'].indexOf(value) >= 0;
      }
    },
    fullScreen: Boolean,
    customClass: String
  },
  data: function data() {
    return {
      isActive: this.active || false,
      savedScrollTop: null,
      newWidth: typeof this.width === 'number' ? this.width + 'px' : this.width,
      animating: true
    };
  },
  computed: {
    cancelOptions: function cancelOptions() {
      return typeof this.canCancel === 'boolean' ? this.canCancel ? config$1.defaultModalCanCancel : [] : this.canCancel;
    },
    showX: function showX() {
      return this.cancelOptions.indexOf('x') >= 0;
    },
    customStyle: function customStyle() {
      if (!this.fullScreen) {
        return {
          maxWidth: this.newWidth
        };
      }

      return null;
    }
  },
  watch: {
    active: function active(value) {
      this.isActive = value;
    },
    isActive: function isActive() {
      this.handleScroll();
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      if (typeof window === 'undefined') return;

      if (this.scroll === 'clip') {
        if (this.isActive) {
          document.documentElement.classList.add('is-clipped');
        } else {
          document.documentElement.classList.remove('is-clipped');
        }

        return;
      }

      this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;

      if (this.isActive) {
        document.body.classList.add('is-noscroll');
      } else {
        document.body.classList.remove('is-noscroll');
      }

      if (this.isActive) {
        document.body.style.top = "-".concat(this.savedScrollTop, "px");
        return;
      }

      document.documentElement.scrollTop = this.savedScrollTop;
      document.body.style.top = null;
      this.savedScrollTop = null;
    },

    /**
    * Close the Modal if canCancel and call the onCancel prop (function).
    */
    cancel: function cancel(method) {
      if (this.cancelOptions.indexOf(method) < 0) return;
      this.onCancel.apply(null, arguments);
      this.close();
    },

    /**
    * Call the onCancel prop (function).
    * Emit events, and destroy modal if it's programmatic.
    */
    close: function close() {
      var _this = this;

      this.$emit('close');
      this.$emit('update:active', false); // Timeout for the animation complete before destroying

      if (this.programmatic) {
        this.isActive = false;
        setTimeout(function () {
          _this.$destroy();

          removeElement(_this.$el);
        }, 150);
      }
    },

    /**
    * Keypress event that is bound to the document.
    */
    keyPress: function keyPress(event) {
      // Esc key
      if (this.isActive && event.keyCode === 27) this.cancel('escape');
    },

    /**
    * Transition after-enter hook
    */
    afterEnter: function afterEnter() {
      this.animating = false;
    },

    /**
    * Transition before-leave hook
    */
    beforeLeave: function beforeLeave() {
      this.animating = true;
    }
  },
  created: function created() {
    if (typeof window !== 'undefined') {
      document.addEventListener('keyup', this.keyPress);
    }
  },
  beforeMount: function beforeMount() {
    // Insert the Modal component in body tag
    // only if it's programmatic
    this.programmatic && document.body.appendChild(this.$el);
  },
  mounted: function mounted() {
    if (this.programmatic) this.isActive = true;else if (this.isActive) this.handleScroll();
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      document.removeEventListener('keyup', this.keyPress); // reset scroll

      document.documentElement.classList.remove('is-clipped');
      var savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
      document.body.classList.remove('is-noscroll');
      document.documentElement.scrollTop = savedScrollTop;
      document.body.style.top = null;
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation},on:{"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave}},[(_vm.isActive)?_c('div',{staticClass:"modal is-active",class:[{'is-full-screen': _vm.fullScreen}, _vm.customClass]},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.cancel('outside');}}}),_vm._v(" "),_c('div',{staticClass:"animation-content",class:{ 'modal-content': !_vm.hasModalCard },style:(_vm.customStyle)},[(_vm.component)?_c(_vm.component,_vm._g(_vm._b({tag:"component",on:{"close":_vm.close}},'component',_vm.props,false),_vm.events)):(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._t("default"),_vm._v(" "),(_vm.showX && !_vm.animating)?_c('button',{staticClass:"modal-close is-large",attrs:{"type":"button"},on:{"click":function($event){_vm.cancel('x');}}}):_vm._e()],2)]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Modal = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/modal.js







var ModalProgrammatic = {
  open: function open(params) {
    var content;
    var parent;
    if (typeof params === 'string') content = params;
    var defaultParam = {
      programmatic: true,
      content: content
    };

    if (params.parent) {
      parent = params.parent;
      delete params.parent;
    }

    var propsData = Object.assign(defaultParam, params);
    var vm = typeof window !== 'undefined' && window.Vue ? window.Vue : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
    var ModalComponent = vm.extend(Modal);
    return new ModalComponent({
      parent: parent,
      el: document.createElement('div'),
      propsData: propsData
    });
  }
};
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Modal);
    registerComponentProgrammatic(Vue, 'modal', ModalProgrammatic);
  }
};
use(Plugin);

/* harmony default export */ var modal = (Plugin);


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalGeneral.vue?vue&type=template&id=650435ae&
var ModalGeneralvue_type_template_id_650435ae_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"},attrs:{"id":"general"}},[_vm._m(0),_c('section',{ref:"PrintBody",staticClass:"modal-card-body footerSourceModal",attrs:{"id":"printBody"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_general'))}})]),_c('footer',{staticClass:"modal-card-foot footerSourceModal-foot"},[_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.print()}}},[_vm._v(_vm._s(_vm.$t('faq.print_text')))]),_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('faq.close_text')))])],1)])])}
var ModalGeneralvue_type_template_id_650435ae_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head footerSourceModal-head"},[_c('p',{staticClass:"modal-card-title footerSourceModal-title"},[_vm._v("FAQ")])])}]


// CONCATENATED MODULE: ./src/components/ModalGeneral.vue?vue&type=template&id=650435ae&

// EXTERNAL MODULE: ./node_modules/printd/index.js
var printd = __webpack_require__("3748");
var printd_default = /*#__PURE__*/__webpack_require__.n(printd);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalGeneral.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_i18n_esm);
external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(modal); // Create VueI18n instance with options

var i18n = new vue_i18n_esm({
  locale: 'en'
});
/* harmony default export */ var ModalGeneralvue_type_script_lang_js_ = ({
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_general: "\n            <h2 class=\"is-size-4\">General</h2>\n            <h3 class=\"is-size-5\">Why are certain industries named and grouped the way they are?</h3>\n            <p>\n              The information presented here is based on the most recent (2017) Canadian version of the \n              <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">North American Industry Classification System</a>. We use the \n              standard titles, definitions, and examples provided in the <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">NAICS handbook</a>.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information for my industry and/or location?</h3>\n            <p>\n              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield \n              results in any province selected.\n            </p>\n            <p>\n              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of \n              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have \n              removed it from our collection.\n            </p>\n            <h3 class=\"is-size-5\">Why am I being shown a different industry and/or location than the one I chose?</h3>\n            <p>\n              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most \n              similar industry or location for which information is available.\n            </p>\n            <p>\n              In the case of location, this often means showing you national instead of provincial information.\n            </p>\n            <p>\n              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not \n              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor \n              homes).\n            </p>",
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_general: "\n            <h2 class=\"is-size-4\">G\xE9n\xE9rale</h2>\n            <h3 class=\"is-size-5\">Pourquoi certains secteurs d'activit\xE9s sont nomm\xE9s et group\xE9s de cette fa\xE7on?</h3>\n            <p>\n              L'information pr\xE9sent\xE9 ici est bas\xE9 sur la version canadienne la plus r\xE9cente (2017) du \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">Syst\xE8me de classification des industries de l'Am\xE9rique du Nord</a>. \n              Nous utilisons les titres, les d\xE9finitions et les exemples standards fourni dans le \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">guide du SCIAN</a>.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver l'information pour mon secteur d'activit\xE9 et/ou l'emplacement?</h3>\n            <p>\n              L'information peut ne pas exist\xE9 dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une esp\xE8ce end\xE9mique du Canada donc l'agriculture \n              du coquelicot ne produirait probablement pas des r\xE9sultats dans l'une ou l'autre des provinces s\xE9lectionn\xE9es.\n            </p>\n            <p>\n              Parfois un secteur d'activit\xE9 est repr\xE9sent\xE9 par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les donn\xE9es sans \n              faire abstraction \xE0 la protection de la vie priv\xE9e de ses entrprises. En d'autre temps, l'information peut \xEAtre inexacte ou manquant. Dans ces cas, Statistique \n              Canada a signal\xE9 les donn\xE9es comme un fonctionnement incertain et nous les avons retir\xE9 de notre collection.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je suis montr\xE9 un secteur d'activit\xE9 et/ou emplacement diff\xE9rent de ce que j'ai choisi?</h3>\n            <p>\n              Nous montrons toujours l'information la plus d\xE9taill\xE9 et sp\xE9cifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va \n              montrer le secteur d'activit\xE9 ou l'emplacement le plus similaire dont l'information est disponible.\n            </p>\n            <p>\n              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.\n            </p>\n            <p>\n              Dans le cas du secteur d'activit\xE9, ceci veut souvent dire qu'on vous montre l'information \xE0 partir d'un secteur plus g\xE9n\xE9rale au lieu d'un secteur d'activit\xE9 \n              sp\xE9cifique que vous avez choisi. Par exemple, nous n'avons peut-\xEAtre pas l'information sur les centres de vill\xE9giature en particulier mais nous avons \n              l'information sur le secteur de l'h\xE9bergement des voyageurs (qui inclus centres de vill\xE9giature, h\xF4tels, motels et maisons motoris\xE9es).\n            </p>",
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function mounted() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function print() {
      var d = new printd_default.a();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

});
// CONCATENATED MODULE: ./src/components/ModalGeneral.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalGeneralvue_type_script_lang_js_ = (ModalGeneralvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function componentNormalizer_normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/ModalGeneral.vue





/* normalize component */

var component = componentNormalizer_normalizeComponent(
  components_ModalGeneralvue_type_script_lang_js_,
  ModalGeneralvue_type_template_id_650435ae_render,
  ModalGeneralvue_type_template_id_650435ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalGeneral = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalFP.vue?vue&type=template&id=b685fa44&
var ModalFPvue_type_template_id_b685fa44_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"},attrs:{"id":"fp"}},[_vm._m(0),_c('section',{ref:"PrintBody",staticClass:"modal-card-body footerSourceModal",attrs:{"id":"PrintBody"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_fp'))}}),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_general'))}})]),_c('footer',{staticClass:"modal-card-foot footerSourceModal-foot"},[_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.print()}}},[_vm._v(_vm._s(_vm.$t('faq.print_text')))]),_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('faq.close_text')))])],1)])])}
var ModalFPvue_type_template_id_b685fa44_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head footerSourceModal-head"},[_c('p',{staticClass:"modal-card-title footerSourceModal-title"},[_vm._v("FAQ")])])}]


// CONCATENATED MODULE: ./src/components/ModalFP.vue?vue&type=template&id=b685fa44&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalFP.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_i18n_esm);
external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(modal); // Create VueI18n instance with options

var ModalFPvue_type_script_lang_js_i18n = new vue_i18n_esm({
  locale: 'en'
});
/* harmony default export */ var ModalFPvue_type_script_lang_js_ = ({
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_fp: "\n            <h2 class=\"is-size-4\">Financial Performance Data</h2>\n            <h3 class=\"is-size-5\">Where did you get this information from?</h3>\n            <p>\n              We downloaded the raw data from the <a href=\"https://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9\" target=\"_blank\">Government of Canada \n              Open Data Portal</a>, which is publicly available. This program contains information licensed under the \n              <a href=\"https://open.canada.ca/en/open-government-licence-canada\" target=\"_blank\">Open Government Licence \u2013 Canada</a>.\n            </p>\n            <h3 class=\"is-size-5\">How can I access this information in a different format?</h3>\n            <p>\n              You can download the raw data in another format from the <a href=\"https://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9\" target=\"_blank\">Government of Canada Open Data Portal</a>, \n              which is publicly available. This program contains information licensed under the <a href=\"https://open.canada.ca/en/open-government-licence-canada\" target=\"_blank\">Open Government Licence \u2013 Canada</a>.\n            </p>\n            <h3 class=\"is-size-5\">How was this information collected?</h3>\n            <p>\n              Financial Performance Data is based on tax return information from all businesses in Canada reporting annual revenue of between $30,000 to $5 million. Because \n              information is collected from all businesses (i.e. a \"census\"), there are no sampling techniques being used.\n            </p>\n            <h3 class=\"is-size-5\">How many people provided information?</h3>\n            <p>\n              Information was provided by the total population of businesses. The exact number depends on how many businesses exist in your chosen region and industry.\n            </p>\n            <h3 class=\"is-size-5\">How often is this updated?</h3>\n            <p>\n              The most current information we have is for 2015. You can get the raw data for more recent year directly from the \n              <a href=\"https://open.canada.ca/data/en/dataset?portal_type=dataset&q=Financial+Performance+Data\" target=\"_blank\">Government of Canada Open Data Portal</a>, \n              which is publicly available.\n            </p>\n            <h3 class=\"is-size-5\">I'm not sure what a term (for example: 'profitable business') means.</h3>\n            <p>\n              Please see the <a href=\"https://www.ic.gc.ca/eic/site/pp-pp.nsf/eng/h_pm00003.html\" target=\"_blank\">Financial Performance Data glossary</a> for definitions of \n              the terms used.\n            </p>\n            <h3 class=\"is-size-5\">What is the difference between what I see here and what is available on the Financial Performance Data website?</h3>\n            <p>\n              We present information in a visual way that is quick and easy to understand. We also allow for easy comparisons between locations and/or industries.\n            </p>\n            <p>\n              However, we only present some of the information that is available. If you are looking for more detailed information (such as breakdowns by quartiles), the \n              <a href=\"https://www.ic.gc.ca/eic/site/pp-pp.nsf/eng/home\" target=\"_blank\">Financial Performance Data website</a> and \n              <a href=\"https://open.canada.ca/data/en/dataset?portal_type=dataset&q=Financial+Performance+Data\" target=\"_blank\">Open Data</a> are better choices.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information on other financial performance measures, like debt to equity ratio?</h3>\n            <p>\n              We are constantly seeking to grow and improve our products. If you have a suggestion for a new type of information you'd like to see, feel free to contact us \n              with your ideas.\n            </p>",
          faq_general: "\n            <h2 class=\"is-size-4\">General</h2>\n            <h3 class=\"is-size-5\">Why are certain industries named and grouped the way they are?</h3>\n            <p>\n              The information presented here is based on the most recent (2017) Canadian version of the \n              <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">North American Industry Classification System</a>. We use the \n              standard titles, definitions, and examples provided in the <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">NAICS handbook</a>.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information for my industry and/or location?</h3>\n            <p>\n              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield \n              results in any province selected.\n            </p>\n            <p>\n              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of \n              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have \n              removed it from our collection.\n            </p>\n            <h3 class=\"is-size-5\">Why am I being shown a different industry and/or location than the one I chose?</h3>\n            <p>\n              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most \n              similar industry or location for which information is available.\n            </p>\n            <p>\n              In the case of location, this often means showing you national instead of provincial information.\n            </p>\n            <p>\n              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not \n              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor \n              homes).\n            </p>",
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_fp: "\n            <h2 class=\"is-size-4\">Donn\xE9es sur la performance financi\xE8re</h2>\n            <h3 class=\"is-size-5\">O\xF9 avez-vous obtenu cette information?</h3>\n            <p>\n              Nous avons t\xE9l\xE9charg\xE9 les donn\xE9es brutes du <a href=\"https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9\" target=\"_blank\">Portal de \n              donn\xE9es ouvert du Gouvernement du Canada</a>, qui est accessible \xE0 tous. Ce programme contient de l'information sous la \n              <a href=\"https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada\" target=\"_blank\">Licence du gouvernement ouvert \u2013 Canada</a>.\n            </p>\n            <h3 class=\"is-size-5\">Comment je peux obtenir cette information sous un autre format?</h3>\n            <p>\n              Vous pouvez t\xE9l\xE9charger les donn\xE9es brutes dans un autre format directement \xE0 partir du site Web \n              <a href=\"https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9\" target=\"_blank\">Portal de donn\xE9es ouvert du Gouvernement du Canada</a>, \n              qui est accessible \xE0 tous. Ce programme contient de l'information sous la \n              <a href=\"https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada\" target=\"_blank\">Licence du gouvernement ouvert \u2013 Canada</a>.\n            </p>\n            <h3 class=\"is-size-5\">Comment l'information a-t-elle \xE9t\xE9 collect\xE9?</h3>\n            <p>\n              Les Donn\xE9es sur la performance financi\xE8re sont bas\xE9s sur l'information des d\xE9clarations de revenus de toutes entreprises au Canada ayant un revenu annuel entre \n              30&nbsp;000&nbsp;$ \xE0 5&nbsp;millions. Parceque l'information est collect\xE9 de toutes les entreprises (ex. : un recensement), il n'y a pas de techniques \n              d'\xE9chantillonnage qui sont utilis\xE9s.\n            </p>\n            <h3 class=\"is-size-5\">Combien de personnes ont fourni de l'information?</h3>\n            <p>\n              L'information a \xE9t\xE9 fourni par la population d'entreprises total. Le nombre exact d\xE9pend sur combien d'entreprises qui existent dans votre r\xE9gion et secteur \n              d'activit\xE9 que vous avez choisi.\n            </p>\n            <h3 class=\"is-size-5\">Quelle est la fr\xE9quence de mise \xE0 jour des donn\xE9es?</h3>\n            <p>\n              L'information la plus courante que nous avons est pour 2015. Vous pouvez obtenir les donn\xE9es brutes pour des ann\xE9es plus r\xE9centes directement du site Web \n              <a href=\"https://ouvert.canada.ca/data/fr/dataset?q=Donn%C3%A9es+sur+la+performance+financi%C3%A8re\" target=\"_blank\">Portal de donn\xE9es ouvert du Gouvernement du \n              Canada</a>, qui est accessible \xE0 tous.\n            </p>\n            <h3 class=\"is-size-5\">Je ne suis pas certain ce qu'un terme (par exemple : 'entreprises rentables') veut dire.</h3>\n            <p>\n              Veuillez consulter <a href=\"https://www.ic.gc.ca/eic/site/pp-pp.nsf/fra/h_pm00003.html\" target=\"_blank\">Glossaire de Donn\xE9es sur la performance financi\xE8re</a> \n              pour les d\xE9finitions des termes utilis\xE9s.\n            </p>\n            <h3 class=\"is-size-5\">Qu'elle est la difference entre ce quoi je trouve ici et ce qui est disponible sur le site Web Donn\xE9es sur la performance financi\xE8re?</h3>\n            <p>\n              Nous pr\xE9sentons l'information dans un visuel qui est vite et facile \xE0 comprendre. Nous permettons aussi des comparaisons facile entre emplacements et/ou secteurs \n              d'activit\xE9s.\n            </p>\n            <p>\n              Cependant, nous pr\xE9sentons seulement certaine information qui sont disponible. Si vous cherchez pour de l'information plus d\xE9taill\xE9e (comme des analyses par \n              quarts), le site Web <a href=\"https://www.ic.gc.ca/eic/site/pp-pp.nsf/fra/accueil\" target=\"_blank\">Donn\xE9es sur la performance financi\xE8re</a> et \n              <a href=\"https://ouvert.canada.ca/data/fr/dataset?q=Donn%C3%A9es+sur+la+performance+financi%C3%A8re\" target=\"_blank\">Donn\xE9es ouvertes</a> sont des meilleurs choix.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver de l'information sur les autres mesures du rendement financier, comme le ratio d'endettement passif-avoir?</h3>\n            <p>\n              Nous sommes constament \xE0 la recherche de d\xE9velopper et d'am\xE9liorer nos produits. Si vous avez une suggestion pour un nouveau type d'information que vous voulez \n              voir, n'h\xE9sitez pas \xE0 nous contacter avec vos id\xE9es.\n            </p>",
          faq_general: "\n            <h2 class=\"is-size-4\">G\xE9n\xE9rale</h2>\n            <h3 class=\"is-size-5\">Pourquoi certains secteurs d'activit\xE9s sont nomm\xE9s et group\xE9s de cette fa\xE7on?</h3>\n            <p>\n              L'information pr\xE9sent\xE9 ici est bas\xE9 sur la version canadienne la plus r\xE9cente (2017) du \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">Syst\xE8me de classification des industries de l'Am\xE9rique du Nord</a>. \n              Nous utilisons les titres, les d\xE9finitions et les exemples standards fourni dans le \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">guide du SCIAN</a>.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver l'information pour mon secteur d'activit\xE9 et/ou l'emplacement?</h3>\n            <p>\n              L'information peut ne pas exist\xE9 dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une esp\xE8ce end\xE9mique du Canada donc l'agriculture \n              du coquelicot ne produirait probablement pas des r\xE9sultats dans l'une ou l'autre des provinces s\xE9lectionn\xE9es.\n            </p>\n            <p>\n              Parfois un secteur d'activit\xE9 est repr\xE9sent\xE9 par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les donn\xE9es sans \n              faire abstraction \xE0 la protection de la vie priv\xE9e de ses entrprises. En d'autre temps, l'information peut \xEAtre inexacte ou manquant. Dans ces cas, Statistique \n              Canada a signal\xE9 les donn\xE9es comme un fonctionnement incertain et nous les avons retir\xE9 de notre collection.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je suis montr\xE9 un secteur d'activit\xE9 et/ou emplacement diff\xE9rent de ce que j'ai choisi?</h3>\n            <p>\n              Nous montrons toujours l'information la plus d\xE9taill\xE9 et sp\xE9cifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va \n              montrer le secteur d'activit\xE9 ou l'emplacement le plus similaire dont l'information est disponible.\n            </p>\n            <p>\n              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.\n            </p>\n            <p>\n              Dans le cas du secteur d'activit\xE9, ceci veut souvent dire qu'on vous montre l'information \xE0 partir d'un secteur plus g\xE9n\xE9rale au lieu d'un secteur d'activit\xE9 \n              sp\xE9cifique que vous avez choisi. Par exemple, nous n'avons peut-\xEAtre pas l'information sur les centres de vill\xE9giature en particulier mais nous avons \n              l'information sur le secteur de l'h\xE9bergement des voyageurs (qui inclus centres de vill\xE9giature, h\xF4tels, motels et maisons motoris\xE9es).\n            </p>",
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function mounted() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function print() {
      var d = new printd_default.a();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

});
// CONCATENATED MODULE: ./src/components/ModalFP.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalFPvue_type_script_lang_js_ = (ModalFPvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/ModalFP.vue





/* normalize component */

var ModalFP_component = componentNormalizer_normalizeComponent(
  components_ModalFPvue_type_script_lang_js_,
  ModalFPvue_type_template_id_b685fa44_render,
  ModalFPvue_type_template_id_b685fa44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalFP = (ModalFP_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalPop.vue?vue&type=template&id=0e6647bc&
var ModalPopvue_type_template_id_0e6647bc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"},attrs:{"id":"pop"}},[_vm._m(0),_c('section',{ref:"PrintBody",staticClass:"modal-card-body footerSourceModal",attrs:{"id":"printBody"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_pop'))}})]),_c('footer',{staticClass:"modal-card-foot footerSourceModal-foot"},[_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.print()}}},[_vm._v(_vm._s(_vm.$t('faq.print_text')))]),_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('faq.close_text')))])],1)])])}
var ModalPopvue_type_template_id_0e6647bc_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head footerSourceModal-head"},[_c('p',{staticClass:"modal-card-title footerSourceModal-title"},[_vm._v("FAQ")])])}]


// CONCATENATED MODULE: ./src/components/ModalPop.vue?vue&type=template&id=0e6647bc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalPop.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_i18n_esm);
external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(modal); // Create VueI18n instance with options

var ModalPopvue_type_script_lang_js_i18n = new vue_i18n_esm({
  locale: 'en'
});
/* harmony default export */ var ModalPopvue_type_script_lang_js_ = ({
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_pop: "\n            <h2 class=\"is-size-4\">Population, by Gender and Age</h2>\n            <h3 class=\"is-size-5\">Where did you get this information from?</h3>\n            <p>\n              We downloaded data tables directly from Statistics Canada's Census program, which is publicly available.\n            </p>\n            <h3 class=\"is-size-5\">How can I access this information in a different format?</h3>\n            <p>\n              You can interact with the dataset in real time at the corresponding Data Tables, 2016 page. There, you can also download the file in a CSV, TAB, IVT (Beyond 20/20), \n              or XML format.\n            </p>\n            <h3 class=\"is-size-5\">How often is this information updated?</h3>\n            <p>\n              The most current information we have is for 2016. The next census will be held in May 2021 and information will be available shortly thereafter.\n            </p>\n            <h3 class=\"is-size-5\">How many people provided information?</h3>\n            <p>\n              Respondents are required by law to complete their census questionnaire, making it an extraordinarily thorough and robust product. Information was provided by the \n              total population of Canada.\n            </p>\n            <h3 class=\"is-size-5\">What about sampling bias?</h3>\n            <p>\n              Because information is collected from all citizens, there are no sampling techniques being used.\n            </p>\n            <h3 class=\"is-size-5\">What is the difference between what I see here and what is available from the Statistics Canada Data Tables?</h3>\n            <p>\n              We present complex information in a visual way that is quick and easy to understand. We also allow for easy comparisons between cities.\n            </p>\n            <p>\n              However, we only present some of the information that is available. If you are looking for more detailed information (such as a breakdown by each individual year \n              of age), please consult the original Statistics Canada Data Tables.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information on other population characteristics, like ethnic diversity or income?</h3>\n            <p>\n              We are constantly seeking to grow and improve our products. If you have a suggestion for a new type of information you'd like to see, feel free to contact us \n              with your ideas.\n            </p>",
          faq_general: "\n            <h2 class=\"is-size-4\">General</h2>\n            <h3 class=\"is-size-5\">Why are certain industries named and grouped the way they are?</h3>\n            <p>\n              The information presented here is based on the most recent (2017) Canadian version of the \n              <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">North American Industry Classification System</a>. We use the \n              standard titles, definitions, and examples provided in the <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">NAICS handbook</a>.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information for my industry and/or location?</h3>\n            <p>\n              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield \n              results in any province selected.\n            </p>\n            <p>\n              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of \n              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have \n              removed it from our collection.\n            </p>\n            <h3 class=\"is-size-5\">Why am I being shown a different industry and/or location than the one I chose?</h3>\n            <p>\n              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most \n              similar industry or location for which information is available.\n            </p>\n            <p>\n              In the case of location, this often means showing you national instead of provincial information.\n            </p>\n            <p>\n              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not \n              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor \n              homes).\n            </p>",
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_pop: "\n            <h2 class=\"is-size-4\">Population, par sexe et \xE2ge</h2>\n            <h3 class=\"is-size-5\">O\xF9 avez-vous obtenu l'information?</h3>\n            <p>\n              Nous avons t\xE9l\xE9charg\xE9 les tableaux de donn\xE9es directement du programme de recensement de Statistique Canada, qui est disponible publiquement.\n            </p>\n            <h3 class=\"is-size-5\">Comment puis-je acc\xE9der \xE0 cette information dans un format diff\xE9rent?</h3>\n            <p>\n              Vous pouvez interagir avec l'ensemble de donn\xE9es en temps r\xE9el \xE0 la page correspondante des tableaux de donn\xE9es de 2016. \xC0 cet endroit, vous pouvez aussi \n              t\xE9l\xE9charger un fichier dans un format CSV, TAB, IVT (Beyond 20/20) ou XML.\n            </p>\n            <h3 class=\"is-size-5\">\xC0 quelle fr\xE9quence l'information est-elle mise \xE0 jour?</h3>\n            <p>\n              L'information la plus courante que nous avons est pour 2016. Le prochain recencement va \xEAtre tenu en mai 2021 et l'information va \xEAtre disponible peu de temps \n              apr\xE8s.\n            </p>\n            <h3 class=\"is-size-5\">Combien de personne ont fourni de l'information?</h3>\n            <p>\n              Les r\xE9pondants sont requis par la loi de compl\xE9ter leur questionnaire du recencement, le fesant un produit extraordinairement complet et robuste. L'information a \n              \xE9t\xE9 fourni par toute la population du Canada.\n            </p>\n            <h3 class=\"is-size-5\">Que dites-vous du biais d'\xE9chantillonnage?</h3>\n            <p>\n              Parce que l'information est r\xE9colt\xE9 par tous les citoyens, il n'y a pas de technique d'\xE9chantillonage qui est utilis\xE9.\n            </p>\n            <h3 class=\"is-size-5\">Quelle est la diff\xE9rence entre ce que je vois ici et ce qui est disponible par les tableaux de donn\xE9es de Statistique Canada?</h3>\n            <p>\n              Nous pr\xE9sentons l'information complexe dans une fa\xE7on visuelle qui est vite et facile \xE0 comprendre. Nous permettons aussi des comparaisons faciles entre les villes.\n            </p>\n            <p>\n              Cependant, nous pr\xE9sentons seulement quelque information qui est disponible. Si vous cherchez pour de l'information plus d\xE9taill\xE9e (tel qu'une d\xE9composition par \n              chaque ann\xE9e d'\xE2ge), veuillez consulter les tableaux de donn\xE9es originaux de Statistique Canada.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver de l'information sur les autres caract\xE9ristiques de la population, comme la diversit\xE9 ethnique ou le revenu?</h3>\n            <p>\n              Nous cherchons constament \xE0 d\xE9velopper et \xE0 am\xE9liorer nos produits. Si vous avez une suggestion pour un nouveau type d'information que vous voulez voir, \n              contactez nous avec vos id\xE9es.\n            </p>",
          faq_general: "\n            <h2 class=\"is-size-4\">G\xE9n\xE9rale</h2>\n            <h3 class=\"is-size-5\">Pourquoi certains secteurs d'activit\xE9s sont nomm\xE9s et group\xE9s de cette fa\xE7on?</h3>\n            <p>\n              L'information pr\xE9sent\xE9 ici est bas\xE9 sur la version canadienne la plus r\xE9cente (2017) du \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">Syst\xE8me de classification des industries de l'Am\xE9rique du Nord</a>. \n              Nous utilisons les titres, les d\xE9finitions et les exemples standards fourni dans le \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">guide du SCIAN</a>.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver l'information pour mon secteur d'activit\xE9 et/ou l'emplacement?</h3>\n            <p>\n              L'information peut ne pas exist\xE9 dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une esp\xE8ce end\xE9mique du Canada donc l'agriculture \n              du coquelicot ne produirait probablement pas des r\xE9sultats dans l'une ou l'autre des provinces s\xE9lectionn\xE9es.\n            </p>\n            <p>\n              Parfois un secteur d'activit\xE9 est repr\xE9sent\xE9 par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les donn\xE9es sans \n              faire abstraction \xE0 la protection de la vie priv\xE9e de ses entrprises. En d'autre temps, l'information peut \xEAtre inexacte ou manquant. Dans ces cas, Statistique \n              Canada a signal\xE9 les donn\xE9es comme un fonctionnement incertain et nous les avons retir\xE9 de notre collection.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je suis montr\xE9 un secteur d'activit\xE9 et/ou emplacement diff\xE9rent de ce que j'ai choisi?</h3>\n            <p>\n              Nous montrons toujours l'information la plus d\xE9taill\xE9 et sp\xE9cifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va \n              montrer le secteur d'activit\xE9 ou l'emplacement le plus similaire dont l'information est disponible.\n            </p>\n            <p>\n              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.\n            </p>\n            <p>\n              Dans le cas du secteur d'activit\xE9, ceci veut souvent dire qu'on vous montre l'information \xE0 partir d'un secteur plus g\xE9n\xE9rale au lieu d'un secteur d'activit\xE9 \n              sp\xE9cifique que vous avez choisi. Par exemple, nous n'avons peut-\xEAtre pas l'information sur les centres de vill\xE9giature en particulier mais nous avons \n              l'information sur le secteur de l'h\xE9bergement des voyageurs (qui inclus centres de vill\xE9giature, h\xF4tels, motels et maisons motoris\xE9es).\n            </p>",
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function mounted() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function print() {
      var d = new printd_default.a();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

});
// CONCATENATED MODULE: ./src/components/ModalPop.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalPopvue_type_script_lang_js_ = (ModalPopvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/ModalPop.vue





/* normalize component */

var ModalPop_component = componentNormalizer_normalizeComponent(
  components_ModalPopvue_type_script_lang_js_,
  ModalPopvue_type_template_id_0e6647bc_render,
  ModalPopvue_type_template_id_0e6647bc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalPop = (ModalPop_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4cbb5fa3-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalWage.vue?vue&type=template&id=056a2f76&
var ModalWagevue_type_template_id_056a2f76_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"},attrs:{"id":"wage"}},[_vm._m(0),_c('section',{ref:"PrintBody",staticClass:"modal-card-body footerSourceModal",attrs:{"id":"printBody"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_wage'))}}),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('faq.faq_general'))}})]),_c('footer',{staticClass:"modal-card-foot footerSourceModal-foot"},[_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.print()}}},[_vm._v(_vm._s(_vm.$t('faq.print_text')))]),_c('b-button',{staticClass:"button",on:{"click":function($event){return _vm.$parent.close()}}},[_vm._v(_vm._s(_vm.$t('faq.close_text')))])],1)])])}
var ModalWagevue_type_template_id_056a2f76_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head footerSourceModal-head"},[_c('p',{staticClass:"modal-card-title footerSourceModal-title"},[_vm._v("FAQ")])])}]


// CONCATENATED MODULE: ./src/components/ModalWage.vue?vue&type=template&id=056a2f76&

// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/chunk-a9a10363.js




var mdiIcons = {
  sizes: {
    'default': 'mdi-24px',
    'is-small': '',
    'is-medium': 'mdi-36px',
    'is-large': 'mdi-48px'
  },
  iconPrefix: 'mdi-'
};

var chunk_a9a10363_faIcons = function faIcons() {
  var faIconPrefix = config$1 && config$1.defaultIconComponent ? '' : 'fa-';
  return {
    sizes: {
      'default': faIconPrefix + 'lg',
      'is-small': '',
      'is-medium': faIconPrefix + '2x',
      'is-large': faIconPrefix + '3x'
    },
    iconPrefix: faIconPrefix,
    internalIcons: {
      'information': 'info-circle',
      'alert': 'exclamation-triangle',
      'alert-circle': 'exclamation-circle',
      'chevron-right': 'angle-right',
      'chevron-left': 'angle-left',
      'chevron-down': 'angle-down',
      'eye-off': 'eye-slash',
      'menu-down': 'caret-down',
      'menu-up': 'caret-up'
    }
  };
};

var chunk_a9a10363_getIcons = function getIcons() {
  var icons = {
    mdi: mdiIcons,
    fa: chunk_a9a10363_faIcons(),
    fas: chunk_a9a10363_faIcons(),
    far: chunk_a9a10363_faIcons(),
    fad: chunk_a9a10363_faIcons(),
    fab: chunk_a9a10363_faIcons()
  };

  if (config$1 && config$1.customIconPacks) {
    icons = chunk_8716473c_merge(icons, config$1.customIconPacks);
  }

  return icons;
};

//
var chunk_a9a10363_script = {
  name: 'BIcon',
  props: {
    type: [String, Object],
    component: String,
    pack: String,
    icon: String,
    size: String,
    customSize: String,
    customClass: String,
    both: Boolean // This is used internally to show both MDI and FA icon

  },
  computed: {
    iconConfig: function iconConfig() {
      var allIcons = chunk_a9a10363_getIcons();
      return allIcons[this.newPack];
    },
    iconPrefix: function iconPrefix() {
      if (this.iconConfig && this.iconConfig.iconPrefix) {
        return this.iconConfig.iconPrefix;
      }

      return '';
    },

    /**
    * Internal icon name based on the pack.
    * If pack is 'fa', gets the equivalent FA icon name of the MDI,
    * internal icons are always MDI.
    */
    newIcon: function newIcon() {
      return "".concat(this.iconPrefix).concat(this.getEquivalentIconOf(this.icon));
    },
    newPack: function newPack() {
      return this.pack || config$1.defaultIconPack;
    },
    newType: function newType() {
      if (!this.type) return;
      var splitType = [];

      if (typeof this.type === 'string') {
        splitType = this.type.split('-');
      } else {
        for (var key in this.type) {
          if (this.type[key]) {
            splitType = key.split('-');
            break;
          }
        }
      }

      if (splitType.length <= 1) return;
      return "has-text-".concat(splitType[1]);
    },
    newCustomSize: function newCustomSize() {
      return this.customSize || this.customSizeByPack;
    },
    customSizeByPack: function customSizeByPack() {
      if (this.iconConfig && this.iconConfig.sizes) {
        if (this.size && this.iconConfig.sizes[this.size] !== undefined) {
          return this.iconConfig.sizes[this.size];
        } else if (this.iconConfig.sizes.default) {
          return this.iconConfig.sizes.default;
        }
      }

      return '';
    },
    useIconComponent: function useIconComponent() {
      return this.component || config$1.defaultIconComponent;
    }
  },
  methods: {
    /**
    * Equivalent icon name of the MDI.
    */
    getEquivalentIconOf: function getEquivalentIconOf(value) {
      // Only transform the class if the both prop is set to true
      if (!this.both) {
        return value;
      }

      if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) {
        return this.iconConfig.internalIcons[value];
      }

      return value;
    }
  }
};

/* script */
const chunk_a9a10363_vue_script_ = chunk_a9a10363_script;

/* template */
var chunk_a9a10363_vue_render_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.newType, _vm.size]},[(!_vm.useIconComponent)?_c('i',{class:[_vm.newPack, _vm.newIcon, _vm.newCustomSize, _vm.customClass]}):_c(_vm.useIconComponent,{tag:"component",class:[_vm.customClass],attrs:{"icon":[_vm.newPack, _vm.newIcon],"size":_vm.newCustomSize}})],1)};
var chunk_a9a10363_vue_staticRenderFns_ = [];

  /* style */
  const chunk_a9a10363_vue_inject_styles_ = undefined;
  /* scoped */
  const chunk_a9a10363_vue_scope_id_ = undefined;
  /* module identifier */
  const chunk_a9a10363_vue_module_identifier_ = undefined;
  /* functional template */
  const chunk_a9a10363_vue_is_functional_template_ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Icon = normalizeComponent_1(
    { render: chunk_a9a10363_vue_render_, staticRenderFns: chunk_a9a10363_vue_staticRenderFns_ },
    chunk_a9a10363_vue_inject_styles_,
    chunk_a9a10363_vue_script_,
    chunk_a9a10363_vue_scope_id_,
    chunk_a9a10363_vue_is_functional_template_,
    chunk_a9a10363_vue_module_identifier_,
    undefined,
    undefined
  );



// CONCATENATED MODULE: ./node_modules/buefy/dist/esm/button.js






var button_script = {
  name: 'BButton',
  components: _defineProperty({}, Icon.name, Icon),
  inheritAttrs: false,
  props: {
    type: [String, Object],
    size: String,
    label: String,
    iconPack: String,
    iconLeft: String,
    iconRight: String,
    rounded: Boolean,
    loading: Boolean,
    outlined: Boolean,
    inverted: Boolean,
    focused: Boolean,
    active: Boolean,
    hovered: Boolean,
    selected: Boolean,
    nativeType: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        return ['button', 'submit', 'reset'].indexOf(value) >= 0;
      }
    },
    tag: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        return ['button', 'a', 'input', 'router-link', 'nuxt-link', 'n-link', 'NuxtLink', 'NLink'].indexOf(value) >= 0;
      }
    }
  },
  computed: {
    iconSize: function iconSize() {
      if (!this.size || this.size === 'is-medium') {
        return 'is-small';
      } else if (this.size === 'is-large') {
        return 'is-medium';
      }

      return this.size;
    }
  }
};

/* script */
const button_vue_script_ = button_script;

/* template */
var button_vue_render_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"button",class:[_vm.size, _vm.type, {
        'is-rounded': _vm.rounded,
        'is-loading': _vm.loading,
        'is-outlined': _vm.outlined,
        'is-inverted': _vm.inverted,
        'is-focused': _vm.focused,
        'is-active': _vm.active,
        'is-hovered': _vm.hovered,
        'is-selected': _vm.selected
    }],attrs:{"type":_vm.nativeType},on:{"click":function($event){_vm.$emit('click', $event);}}},'component',_vm.$attrs,false),[(_vm.iconLeft)?_c('b-icon',{attrs:{"pack":_vm.iconPack,"icon":_vm.iconLeft,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.iconRight)?_c('b-icon',{attrs:{"pack":_vm.iconPack,"icon":_vm.iconRight,"size":_vm.iconSize}}):_vm._e()],1)};
var button_vue_staticRenderFns_ = [];

  /* style */
  const button_vue_inject_styles_ = undefined;
  /* scoped */
  const button_vue_scope_id_ = undefined;
  /* module identifier */
  const button_vue_module_identifier_ = undefined;
  /* functional template */
  const button_vue_is_functional_template_ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Button = normalizeComponent_1(
    { render: button_vue_render_, staticRenderFns: button_vue_staticRenderFns_ },
    button_vue_inject_styles_,
    button_vue_script_,
    button_vue_scope_id_,
    button_vue_is_functional_template_,
    button_vue_module_identifier_,
    undefined,
    undefined
  );

var button_Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Button);
  }
};
use(button_Plugin);

/* harmony default export */ var esm_button = (button_Plugin);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ModalWage.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_i18n_esm);
external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(modal);
external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(esm_button); // Create VueI18n instance with options

var ModalWagevue_type_script_lang_js_i18n = new vue_i18n_esm({
  locale: 'en'
});
/* harmony default export */ var ModalWagevue_type_script_lang_js_ = ({
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_general: "\n            <h2 class=\"is-size-4\">General</h2>\n            <h3 class=\"is-size-5\">Why are certain industries named and grouped the way they are?</h3>\n            <p>\n              The information presented here is based on the most recent (2017) Canadian version of the \n              <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">North American Industry Classification System</a>. We use the \n              standard titles, definitions, and examples provided in the <a href=\"http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction\" target=\"_blank\">NAICS handbook</a>.\n            </p>\n            <h3 class=\"is-size-5\">Why can't I find information for my industry and/or location?</h3>\n            <p>\n              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield \n              results in any province selected.\n            </p>\n            <p>\n              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of \n              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have \n              removed it from our collection.\n            </p>\n            <h3 class=\"is-size-5\">Why am I being shown a different industry and/or location than the one I chose?</h3>\n            <p>\n              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most \n              similar industry or location for which information is available.\n            </p>\n            <p>\n              In the case of location, this often means showing you national instead of provincial information.\n            </p>\n            <p>\n              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not \n              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor \n              homes).\n            </p>",
          faq_wage: "\n            <h2 class=\"is-size-4\">Median Hourly Full-time Wage</h2>\n            <h3 class=\"is-size-5\">What is the wage data for?</h3>\n            <p>\n              The wage data widget is intended to provide insight into the hourly wage for a given occupation within economic regions of Canada. The dataset we use is \n              prepared by the Labour Market Data, Methods and Analysis Division of Employment and Social Development Canada (ESDC) and it is used in the trends and analysis \n              section of the Government of Canada\u2019s <a href=\"https://www.jobbank.gc.ca/trend-analysis\" target=\"_blank\">Job Bank website</a>.\n            </p>\n            <p>\n              The median is used for hourly wage for an occupation. The median wage is preferred over the average wage because it is less sensitive to extreme values and \n              more representative of the typical worker's salary.\n            </p>\n            <p>\n              Occupations are classified using the National Occupation Classification system at the four-digit level.\n            </p>\n            <p>\n              Location data is presented by the Economic Region, a variant of the Standard Geographical Region statistical classification system created by Statistics Canada \n              as a standard geographic unit for the analysis of economic activity within 76 regions across Canada. In our widget, each location is linked to its respective \n              economic region.\n            </p>\n            <h3 class=\"is-size-5\">Which sources of data are used?</h3>\n            <p>\n              Wages are determined using a joint <abbr title=\"Employment and Social Development Canada\">ESDC</abbr> and Statistics Canada methodology. \n              <abbr title=\"Employment and Social Development Canada\">ESDC</abbr> consults other stakeholders during the validation process, such as provincial and territorial \n              governments, other federal departments and external organizations.\n            </p>\n            <p>\n              As the primary source of the dataset, <abbr title=\"Employment and Social Development Canada\">ESDC</abbr> uses Statistics Canada's Labour Force Survey:\n            </p>\n            <ul>\n              <li>the most inclusive, timely and unbiased source of wage data by occupational group</li>\n              <li>this survey is conducted using a sample of respondents</li>\n              <li>data may be suppressed for reasons of confidentiality or data quality</li>\n            </ul>\n            <p>\n              When the Labour Force Survey data are not available, other sources are considered, including:\n            </p>\n            <ul>\n              <li><abbr title=\"Employment and Social Development Canada\">ESDC</abbr> program data such as Employment Insurance program survey data</li>\n              <li>the Census</li>\n              <li>provincial and territorial surveys and administrative data</li>\n              <li>other organizations administrative data</li>\n            </ul>\n            <p>\n              For the complete process followed by <abbr title=\"Employment and Social Development Canada\">ESDC</abbr>, please see their \n              <a href=\"https://www.jobbank.gc.ca/trend-analysis/search-wages/wage-methodology\" target=\"_blank\">Wage Methodology</a>.\n            </p>\n            <h3 class=\"is-size-5\">Have you manipulated the original dataset?</h3>\n            <p>\n              We have removed from the dataset salaries that were presented as an annual salary versus an hourly wage. However, this data can be found from the original source.\n            </p>\n            <h3 class=\"is-size-5\">Why is there no data available for some combinations of occupation and location?</h3>\n            <p>\n              It is not always possible to determine occupational wages for all economic regions due to data limitations (suppression of data due to low quality and privacy \n              reasons). When this is the case, we will display the minimum wage of the province or territory. When comparing locations or industries, these values will appear \n              as not available (n/a) and without the minimum wage.\n            </p>\n            <h3 class=\"is-size-5\">How are you able to pull occupational data by searching for an industry?</h3>\n            <p>\n              We have done an extensive analysis to develop a mapping of occupations by industries. Through concordance tables, we are able to link wage data by occupation to \n              their related industries.\n            </p>\n            <h3 class=\"is-size-5\">Which datasets is used by the widget?</h3>\n            <p>\n              Our widget is using the <abbr title=\"Employment and Social Development Canada\">ESDC</abbr> 2019 Wages Dataset, which can be downloaded from the Government of Canada's <a href=\"https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116\" target=\"_blank\">Open Data website</a>.\n            </p>\n            <h3 class=\"is-size-5\">How soon is the widget updated after a new wage data version is released?</h3>\n            <p>\n              We aim to update the data within 3 months of the new release of new dataset. This dataset is produced yearly, and it is published in the late fall.\n            </p>\n            <h3 class=\"is-size-5\">Attribution statement</h3>\n            <p> \n              Contains information licensed under the <a href=\"https://open.canada.ca/en/open-government-licence-canada\" target=\"_blank\">Open Government Licence \u2013 Canada</a>\n            </p>",
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_general: "\n            <h2 class=\"is-size-4\">G\xE9n\xE9rale</h2>\n            <h3 class=\"is-size-5\">Pourquoi certains secteurs d'activit\xE9s sont nomm\xE9s et group\xE9s de cette fa\xE7on?</h3>\n            <p>\n              L'information pr\xE9sent\xE9 ici est bas\xE9 sur la version canadienne la plus r\xE9cente (2017) du \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">Syst\xE8me de classification des industries de l'Am\xE9rique du Nord</a>. \n              Nous utilisons les titres, les d\xE9finitions et les exemples standards fourni dans le \n              <a href=\"https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction\" target=\"_blank\">guide du SCIAN</a>.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je ne peux trouver l'information pour mon secteur d'activit\xE9 et/ou l'emplacement?</h3>\n            <p>\n              L'information peut ne pas exist\xE9 dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une esp\xE8ce end\xE9mique du Canada donc l'agriculture \n              du coquelicot ne produirait probablement pas des r\xE9sultats dans l'une ou l'autre des provinces s\xE9lectionn\xE9es.\n            </p>\n            <p>\n              Parfois un secteur d'activit\xE9 est repr\xE9sent\xE9 par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les donn\xE9es sans \n              faire abstraction \xE0 la protection de la vie priv\xE9e de ses entrprises. En d'autre temps, l'information peut \xEAtre inexacte ou manquant. Dans ces cas, Statistique \n              Canada a signal\xE9 les donn\xE9es comme un fonctionnement incertain et nous les avons retir\xE9 de notre collection.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi je suis montr\xE9 un secteur d'activit\xE9 et/ou emplacement diff\xE9rent de ce que j'ai choisi?</h3>\n            <p>\n              Nous montrons toujours l'information la plus d\xE9taill\xE9 et sp\xE9cifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va \n              montrer le secteur d'activit\xE9 ou l'emplacement le plus similaire dont l'information est disponible.\n            </p>\n            <p>\n              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.\n            </p>\n            <p>\n              Dans le cas du secteur d'activit\xE9, ceci veut souvent dire qu'on vous montre l'information \xE0 partir d'un secteur plus g\xE9n\xE9rale au lieu d'un secteur d'activit\xE9 \n              sp\xE9cifique que vous avez choisi. Par exemple, nous n'avons peut-\xEAtre pas l'information sur les centres de vill\xE9giature en particulier mais nous avons \n              l'information sur le secteur de l'h\xE9bergement des voyageurs (qui inclus centres de vill\xE9giature, h\xF4tels, motels et maisons motoris\xE9es).\n            </p>",
          faq_wage: "\n            <h2 class=\"is-size-4\">Salaire horaire m\xE9dian \xE0 temps plein</h2>\n            <h3 class=\"is-size-5\">Quelle est l'utilit\xE9 des donn\xE9es sur les salaires?</h3>\n            <p>\n              Le widget de donn\xE9es sur les salaires vise \xE0 donner un aper\xE7u du salaire horaire pour une profession donn\xE9e dans les r\xE9gions \xE9conomiques du Canada.\n            </p>\n            <p>\n              Le jeu de donn\xE9es que nous utilisons est pr\xE9par\xE9 par la Division des donn\xE9es, M\xE9thodes et analyse du march\xE9 du travail d'Emploi et D\xE9veloppement social Canada (EDSC) \n              o\xF9 il est utilis\xE9 dans la section d\u2019analyse des tendances du <a href=\"https://www.guichetemplois.gc.ca/analyse-tendances\" target=\"_blank\">site Web du Guichet \n              emplois</a> du gouvernement du Canada.\n            </p>\n            <p>\n              La m\xE9diane est utilis\xE9e pour le salaire horaire d'une profession. Le salaire m\xE9dian est pr\xE9f\xE9r\xE9 au salaire moyen car il est moins sensible aux valeurs extr\xEAmes et \n              plus repr\xE9sentatif du salaire type du travailleur.\n            </p>\n            <p>\n              Les professions sont class\xE9es \xE0 l'aide du syst\xE8me de Classification nationale des professions au niveau des codes \xE0 quatre chiffres.\n            </p>\n            <p>\n              Les donn\xE9es d\u2019emplacement sont pr\xE9sent\xE9es par r\xE9gion \xE9conomique, une variante du syst\xE8me de Classification g\xE9ographique type, normalis\xE9es cr\xE9\xE9 par Statistique \n              Canada en tant qu'unit\xE9 g\xE9ographique standard pour l'analyse de l'activit\xE9 \xE9conomique dans 76 r\xE9gions du Canada. Dans notre widget, chaque emplacement est li\xE9 \n              \xE0 sa r\xE9gion \xE9conomique.\n            </p>\n            <h3 class=\"is-size-5\">Quelles sources de donn\xE9es sont utilis\xE9es?</h3>\n            <p>\n              Les salaires sont d\xE9termin\xE9s \xE0 l'aide d'une m\xE9thodologie conjointe d'<abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr> et de Statistique Canada. \n              <abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr> consulte d'autres intervenants au cours du processus de validation, comme les gouvernements \n              provinciaux et territoriaux, d'autres minist\xE8res f\xE9d\xE9raux et des organismes externes.\n            </p>\n            <p>\n              En tant que source principale du jeu de donn\xE9es, <abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr> utilise l'Enqu\xEAte sur la population active \n              de Statistique Canada :\n            </p>\n            <ul>\n              <li>la source de donn\xE9es sur les salaires par groupe professionnel la plus inclusive, opportune et impartiale;</li>\n              <li>cette enqu\xEAte est men\xE9e aupr\xE8s d'un \xE9chantillon de r\xE9pondants;</li>\n              <li>les donn\xE9es peuvent \xEAtre supprim\xE9es pour des raisons de confidentialit\xE9 ou de qualit\xE9 des donn\xE9es.</li>\n            </ul>\n            <p>\n              Lorsque les donn\xE9es de l'Enqu\xEAte sur la population active ne sont pas disponibles, d'autres sources sont envisag\xE9es, notamment :\n            </p>\n            <ul>\n              <li>les donn\xE9es du programme d'<abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr>, comme les donn\xE9es d'enqu\xEAte sur le programme d'assurance-emploi;</li>\n              <li>le recensement;</li>\n              <li>les enqu\xEAtes provinciales et territoriales et les donn\xE9es administratives;</li>\n              <li>autres donn\xE9es administratives des organisations.</li>\n            </ul>\n            <p>\n              Pour le processus complet suivi par <abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr>, veuillez consulter leur \n              <a href=\"https://www.guichetemplois.gc.ca/analyse-tendances/recherche-salaires/methodologie-salaires\" target=\"_blank\">m\xE9thodologie des salaires</a>.\n            </p>\n            <h3 class=\"is-size-5\">Avez-vous manipul\xE9 le jeu de donn\xE9es d'origine?</h3>\n            <p>\n              Nous avons supprim\xE9 du jeu de donn\xE9es les salaires qui \xE9taient pr\xE9sent\xE9s comme un salaire annuel au lieu d\u2019un salaire horaire. Cependant, ces donn\xE9es peuvent \n              \xEAtre trouv\xE9es \xE0 partir de la source d'origine.\n            </p>\n            <h3 class=\"is-size-5\">Pourquoi n'y a-t-il pas de donn\xE9es disponibles pour certaines combinaisons de profession et d\u2019emplacement?</h3>\n            <p>\n              Il n'est pas toujours possible de d\xE9terminer les salaires des professions pour toutes les r\xE9gions \xE9conomiques en raison des limites des donn\xE9es (suppression \n              des donn\xE9es pour des raisons de faible qualit\xE9 et de confidentialit\xE9). Lorsque c'est le cas, nous afficherons le salaire minimum de la province ou du territoire. \n              Lorsque vous comparez des emplacements ou des secteurs d\u2019activit\xE9s, ces valeurs non disponibles afficheront comme \xE9tant sans objet (s.o.) et sans le salaire minimum.\n            </p>\n            <h3 class=\"is-size-5\">Comment pouvez-vous extraire des donn\xE9es sur les professions en recherchant un secteur d\u2019activit\xE9?</h3>\n            <p>\n              Nous avons effectu\xE9 une analyse approfondie pour \xE9laborer une cartographie des professions par secteur d\u2019activit\xE9s. Gr\xE2ce \xE0 des tableaux de concordance, \n              nous pouvons relier les donn\xE9es sur les salaires par profession \xE0 leurs secteurs d\u2019activit\xE9s connexes.\n            </p>\n            <h3 class=\"is-size-5\">Quel jeu de donn\xE9es est utilis\xE9s par le widget?</h3>\n            <p>\n              Notre widget utilise le jeu de donn\xE9es sur les salaires d'<abbr title=\"Emploi et D\xE9veloppement social Canada\">EDSC</abbr> 2019, qui peut \xEAtre t\xE9l\xE9charg\xE9 \xE0 partir \n              du <a href=\"https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116\" target=\"_blank\">site Web de donn\xE9es ouvertes</a> du gouvernement du Canada.\n            </p>\n            <h3 class=\"is-size-5\">Combien de temps le widget est-il mis \xE0 jour suite \xE0 la publication d'une nouvelle version des donn\xE9es sur les salaires?</h3>\n            <p>\n              Notre objectif est de mettre \xE0 jour les donn\xE9es dans les 3 mois suivant la nouvelle version du nouveau jeu de donn\xE9es. Ce jeu de donn\xE9es est produit chaque ann\xE9e \n              et publi\xE9 \xE0 la fin de l'automne.\n            </p>\n            <h3 class=\"is-size-5\">\xC9nonc\xE9 d'attribution</h3>\n            <p> \n              Contient de l'information vis\xE9e par la <a href=\"https://ouvert.canada.ca/fr/licence-du-gouvernement-ouvert-canada\" target=\"_blank\">Licence du gouvernement ouvert \u2013 Canada</a>\n            </p>",
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  },
  // end i18n
  props: ['lang'],
  mounted: function mounted() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    print: function print() {
      var d = new printd_default.a();
      d.print(this.$refs.PrintBody);
    }
  } // end methods

});
// CONCATENATED MODULE: ./src/components/ModalWage.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ModalWagevue_type_script_lang_js_ = (ModalWagevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/ModalWage.vue





/* normalize component */

var ModalWage_component = componentNormalizer_normalizeComponent(
  components_ModalWagevue_type_script_lang_js_,
  ModalWagevue_type_template_id_056a2f76_render,
  ModalWagevue_type_template_id_056a2f76_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModalWage = (ModalWage_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/FAQ.vue?vue&type=script&lang=js&
//
//
//
//
//
//






external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(modal);
/* harmony default export */ var FAQvue_type_script_lang_js_ = ({
  props: ['lang', 'faq'],
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    openModal: function openModal() {
      this.$buefy.modal.open({
        props: {
          'lang': this.toggleLang
        },
        parent: this,
        component: this.faq == "fp" ? ModalFP : this.faq == "pop" ? ModalPop : this.faq == "wage" ? ModalWage : ModalGeneral,
        hasModalCard: true
      });
    }
  } // end methods

});
// CONCATENATED MODULE: ./src/components/FAQ.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_FAQvue_type_script_lang_js_ = (FAQvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/FAQ.vue?vue&type=style&index=0&lang=css&
var FAQvue_type_style_index_0_lang_css_ = __webpack_require__("26a2");

// CONCATENATED MODULE: ./src/components/FAQ.vue






/* normalize component */

var FAQ_component = componentNormalizer_normalizeComponent(
  components_FAQvue_type_script_lang_js_,
  FAQvue_type_template_id_5fcb1ad6_render,
  FAQvue_type_template_id_5fcb1ad6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FAQ = (FAQ_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SourceFooter.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SourceFootervue_type_script_lang_js_ = ({
  props: ['lang', 'summary', 'source', 'summaryContent', 'faq'],
  components: {
    'faq-link': FAQ
  },
  data: function data() {
    return {
      FooterisOpen: false
    };
  },
  // data
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  },
  // end computed
  methods: {
    simulateClick: function simulateClick() {
      this.FooterisOpen = !this.FooterisOpen;
    }
  } //methods

}); // default
// CONCATENATED MODULE: ./src/components/SourceFooter.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SourceFootervue_type_script_lang_js_ = (SourceFootervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/SourceFooter.vue?vue&type=style&index=0&lang=css&
var SourceFootervue_type_style_index_0_lang_css_ = __webpack_require__("3de3");

// CONCATENATED MODULE: ./src/components/SourceFooter.vue






/* normalize component */

var SourceFooter_component = componentNormalizer_normalizeComponent(
  components_SourceFootervue_type_script_lang_js_,
  SourceFootervue_type_template_id_782032f0_render,
  SourceFootervue_type_template_id_782032f0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SourceFooter = (SourceFooter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseFooter.vue?vue&type=script&lang=js&
//
//
//
//
//
//



external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_i18n_esm); // Create VueI18n instance with options

var BaseFootervue_type_script_lang_js_i18n = new vue_i18n_esm({
  locale: 'en'
});
/* harmony default export */ var BaseFootervue_type_script_lang_js_ = ({
  name: "WidgetBaseFooter",
  i18n: {
    locale: "en",
    messages: {
      en: {
        source: {
          sgc_source: 'Source:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=314300">Standard Geographical Classification (SGC) 2016, Statistics Canada</a>',
          sgc_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=314300">Data Source</a>',
          sgc_summary_content: '',
          naics_source: 'Source:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=380372">North American Industry Classification System (NAICS) Canada 2017, Statistics Canada</a>',
          naics_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=380372">Data Source</a>',
          naics_summary_content: '',
          fp_source: 'Source:&nbsp;<a href="http://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Financial Performance Data, ISED, 2015</a>',
          fp_source_mobile: '<a href="http://open.canada.ca/data/en/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Data Source</a>',
          fp_summary_content: 'No calculations have been made. See our FAQ page for more information on the original dataset.',
          pop_source: 'Source:&nbsp;<a href="http://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-eng.cfm?TABID=2&amp;LANG=E&amp;A=R&amp;APATH=3&amp;DETAIL=0&amp;DIM=0&amp;FL=A&amp;FREE=0&amp;GC=01&amp;GL=-1&amp;GID=1159582&amp;GK=1&amp;GRP=1&amp;O=D&amp;PID=109526&amp;PRID=10&amp;PTYPE=109445&amp;S=0&amp;SHOWALL=0&amp;SUB=0&amp;Temporal=2016&amp;THEME=115&amp;VID=0&amp;VNAMEE=&amp;VNAMEF=&amp;D1=0&amp;D2=0&amp;D3=0&amp;D4=0&amp;D5=0&amp;D6=0" target="_blank">Census, Statistics Canada, 2016</a>',
          pop_summary_content: '',
          wage_source: 'Source:&nbsp;<a href="https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Wages Dataset, Employment and Social Development Canada (ESDC), 2019</a>',
          wage_source_mobile: '<a href="https://open.canada.ca/data/en/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Data Source</a>',
          wage_summary_content: 'Some combinations of industry and location may not have data due to data limitations. No calculations have been made. Find more information in our FAQ.',
          tenders_source: 'Source:&nbsp;<a href="http://buyandsell.gc.ca" target="_blank">Buyandsell.gc.ca, Public Works and Government Services Canada, 2018</a>',
          tenders_source_mobile: '<a href="http://buyandsell.gc.ca" target="_blank">Buyandsell.gc.ca, Public Works and Government Services Canada, 2018</a>',
          tenders_summary_content: 'Have questions about Government Tenders? Let us help! Call the BuyandSell InfoLine at 1-800-811-1148. We are here to help you do business with the Government of Canada.',
          permit_source: 'Source:&nbsp;<a href="https://www.bizpal.ca/" target="_blank">BizPaL, ISED, 2018</a>',
          permit_source_mobile: '<a href="https://www.bizpal.ca/" target="_blank">Data Source</a>',
          permit_summary_content: 'Information comes from many different federal departments and agencies, as well as external sources and other levels of government. Every effort is made to ensure the accuracy, currency and reliability of the content.'
        }
      },
      fr: {
        source: {
          sgc_source: 'Source&nbsp;:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=314300">Classification géographique type (CGT) 2016, Statistique Canada</a>',
          sgc_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=314300">Source de données</a>',
          sgc_summary_content: '',
          naics_source: 'Source&nbsp;:&nbsp;<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=380372">Système de classification des industries de l\'Amérique du Nord (SCIAN) Canada 2017, Statistique Canada</a>',
          naics_source_mobile: '<a href="http://www23.statcan.gc.ca/imdb/p3VD_f.pl?Function=getVD&TVD=380372">Source de données</a>',
          naics_summary_content: '',
          fp_source: 'Source :&nbsp;<a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Données sur la performance financière, ISDE, 2015</a>',
          fp_summary_content: 'Aucune calculation n\'a été effectué. Voir notre page FAQ pour plus d\'information sur l\'ensemble de donnée original.',
          fp_source_mobile: '<a href="https://ouvert.canada.ca/data/fr/dataset/f559526c-40f9-4c5d-bced-0f7a41f278b9" target="_blank">Source de données</a>',
          pop_source: 'Source&nbsp;:&nbsp;<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-fra.cfm?TABID=2&LANG=F&A=R&APATH=3&DETAIL=0&DIM=0&FL=A&FREE=0&GC=01&GL=-1&GID=1159582&GK=1&GRP=1&O=D&PID=109526&PRID=10&PTYPE=109445&S=0&SHOWALL=0&SUB=0&Temporal=2016&THEME=115&VID=0&VNAMEE=&VNAMEF=&D1=0&D2=0&D3=0&D4=0&D5=0&D6=0" target="_blank">Recensement, Statistique Canada, 2016</a>',
          pop_source_mobile: '<a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/dt-td/Rp-fra.cfm?TABID=2&LANG=F&A=R&APATH=3&DETAIL=0&DIM=0&FL=A&FREE=0&GC=01&GL=-1&GID=1159582&GK=1&GRP=1&O=D&PID=109526&PRID=10&PTYPE=109445&S=0&SHOWALL=0&SUB=0&Temporal=2016&THEME=115&VID=0&VNAMEE=&VNAMEF=&D1=0&D2=0&D3=0&D4=0&D5=0&D6=0" target="_blank">Source de données</a>',
          pop_summary_content: '',
          wage_source: 'Source&nbsp;:&nbsp;<a href="https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Jeu de données sur les salaires, Emploi et Développement social Canada (EDSC), 2019</a>',
          wage_source_mobile: '<a href="https://ouvert.canada.ca/data/fr/dataset/adad580f-76b0-4502-bd05-20c125de9116" target="_blank">Source de données</a>',
          wage_summary_content: 'Certaines combinaisons de secteur d’activité et d’emplacement peuvent ne pas avoir de données en raison de limites des données. Aucun calcul n\'a été effectué. Obtenez plus de renseignement dans la FAQ.',
          tenders_source: 'Source&nbsp;:&nbsp;<a href="https://achatsetventes.gc.ca/" target="_blank">Achatsetventes.gc.ca, Travaux publics et Services gouvernementaux Canada, 2018</a>',
          tenders_source_mobile: '<a href="https://achatsetventes.gc.ca/" target="_blank">Source de données</a>',
          tenders_summary_content: 'Vous avez des questions? Laissez-nous vous aider! Appelez la LigneInfo au 1-800-811-1148. Nous sommes là pour vous aider à faire affaire avec le gouvernement du Canada.',
          permit_source: 'Source&nbsp;:&nbsp;<a href="https://www.perle-bizpal.ca/fr/" target="_blank">PerLE, ISDE, 2018</a>',
          permit_source_mobile: '<a href="https://www.perle-bizpal.ca/fr/" target="_blank">Source de données</a>',
          permit_summary_content: 'L\'information provient de plusieurs ministères et agences du gouvernement fédéral, ainsi que des sources externes et autres niveaux de gouvernement. Tous les efforts sont fait pour assurer l\'exactitude, l\'actualité et la fiabilité du contenu.'
        }
      }
    }
  },
  props: {
    lang: {
      type: String,
      default: "en"
    },
    widget: {
      type: String
    }
  },
  data: function data() {
    return {
      faq: "",
      //sources
      source: "",
      summary: false,
      //set to true to show if there is a summary entered in summaryContent
      summaryContent: ""
    };
  },
  // end data
  mounted: function mounted() {
    var screenWidth = window.innerWidth;
    var isMobile = screenWidth < 768 ? true : false;
    this.$i18n.locale = this.toggleLang;

    if (this.widget == "sgc") {
      this.source = isMobile ? this.$t('source.sgc_source_mobile') : this.$t('source.sgc_source');
      this.summaryContent = this.$t('source.sgc_summary_content');
      this.summary = false;
      this.faq = null; //no FAQ
    } else if (this.widget == "naics") {
      this.source = isMobile ? this.$t('source.naics_source_mobile') : this.$t('source.naics_source');
      this.summaryContent = this.$t('source.naics_summary_content');
      this.summary = false;
      this.faq = "general";
    } else if (this.widget == "pop") {
      this.source = isMobile ? this.$t('source.pop_source_mobile') : this.$t('source.pop_source');
      this.summaryContent = this.$t('source.pop_summary_content');
      this.summary = false;
      this.faq = "pop";
    } else if (this.widget == "fp") {
      this.source = isMobile ? this.$t('source.fp_source_mobile') : this.$t('source.fp_source');
      this.summaryContent = this.$t('source.fp_summary_content');
      this.summary = true;
      this.faq = "fp";
    } else if (this.widget == "wage") {
      this.source = isMobile ? this.$t('source.wage_source_mobile') : this.$t('source.wage_source');
      this.summaryContent = this.$t('source.wage_summary_content');
      this.summary = true;
      this.faq = "wage";
    } else if (this.widget == "permit") {
      this.source = isMobile ? this.$t('source.permit_source_mobile') : this.$t('source.permit_source');
      this.summaryContent = this.$t('source.permit_summary_content');
      this.summary = true;
      this.faq = "general";
    } else if (this.widget == "tenders") {
      this.source = isMobile ? this.$t('source.tenders_source_mobile') : this.$t('source.tenders_source');
      this.summaryContent = this.$t('source.tenders_summary_content');
      this.summary = true;
      this.faq = "general";
    }
  },
  // end mounted
  components: {
    "source-footer": SourceFooter
  },
  // end component
  computed: {
    toggleLang: function toggleLang() {
      return this.lang;
    }
  } // end computed

}); // end export
// CONCATENATED MODULE: ./src/components/BaseFooter.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseFootervue_type_script_lang_js_ = (BaseFootervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/BaseFooter.vue?vue&type=style&index=0&lang=css&
var BaseFootervue_type_style_index_0_lang_css_ = __webpack_require__("5446");

// CONCATENATED MODULE: ./src/components/BaseFooter.vue






/* normalize component */

var BaseFooter_component = componentNormalizer_normalizeComponent(
  components_BaseFootervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseFooter = (BaseFooter_component.exports);
// CONCATENATED MODULE: ./src/components/index.js






var Components = {
  BaseFooter: BaseFooter
};
Object.keys(Components).forEach(function (name) {
  external_commonjs_vue_commonjs2_vue_root_Vue_default.a.component(name, Components[name]);
});
/* harmony default export */ var components = (Components);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (components);



/***/ })

/******/ });
//# sourceMappingURL=open-services-footer-widget.common.js.map